var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import { MENU_CHANNEL } from "~/config/enum.config";
import { State } from 'vuex-class';
import { CaseApplyRecordService } from '~/services/domain-service/case-apply-record.service';
import CaseApprovalCommon from '~/components/approval-manage/own-approval/case-approval-common.vue';
var OwnApproval = /** @class */ (function (_super) {
    __extends(OwnApproval, _super);
    function OwnApproval() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ownModel = {
            caseNumber: '',
            applyCategory: '',
            applyRealName: '',
            checkRealName: '',
            applyStatus: '',
            applyTime: [],
        };
        _this.rowData = '';
        _this.ownDataSet = [];
        _this.dialog = {
            leaveApproval: false,
        };
        return _this;
    }
    Object.defineProperty(OwnApproval.prototype, "userId", {
        get: function () {
            return this.userData.id;
        },
        enumerable: false,
        configurable: true
    });
    OwnApproval.prototype.params = function () {
        var params = __assign({}, this.ownModel);
        params.applyTimeMin = this.ownModel.applyTime.length ? this.$filter.dateTimeFormat(this.ownModel.applyTime[0]) : '';
        params.applyTimeMax = this.ownModel.applyTime.length ? this.$filter.dateTimeFormat(this.ownModel.applyTime[1]) : '';
        delete params.applyTime;
        return params;
    };
    OwnApproval.prototype.approvalClick = function (scope) {
        this.rowData = scope.row;
        this.dialog.leaveApproval = true;
    };
    OwnApproval.prototype.mounted = function () {
        this.refreshData();
    };
    OwnApproval.prototype.refreshData = function () {
        var _this = this;
        this.caseApplyRecordService
            .getAllCaseApplyRecords(this.params(), this.pageService, {
            applyTime: 'desc',
        })
            .subscribe(function (data) {
            _this.ownDataSet = data;
        });
    };
    /**
     * 导出库管审批
     */
    OwnApproval.prototype.onClickExport = function () {
        var _this = this;
        if (!this.ownDataSet.length)
            return this.$message.warning('暂无数据无需导出！');
        this.caseApplyRecordService.warehouseApprovalExport(this.params()).subscribe(function (data) {
            _this.$common.downloadFile(data.url);
        });
    };
    /**
     * 进入查看执行页
     */
    OwnApproval.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Visit_team,
            otherData: {
                data: this.ownDataSet,
                page: this.pageService,
                sort: this.sortService
            }
        });
    };
    __decorate([
        Dependencies(PageService)
    ], OwnApproval.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], OwnApproval.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], OwnApproval.prototype, "caseApplyRecordService", void 0);
    __decorate([
        State
    ], OwnApproval.prototype, "userData", void 0);
    OwnApproval = __decorate([
        Auth(1701),
        Layout('workspace'),
        Component({
            components: {
                CaseApprovalCommon: CaseApprovalCommon,
            },
        })
    ], OwnApproval);
    return OwnApproval;
}(Vue));
export default OwnApproval;
